/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser
 */
export interface JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser
     */
    userName?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser
     */
    userNameKana?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser
     */
    userRelationShip?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser
     */
    userAge?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser
     */
    userFamilyName?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser
     */
    userFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser
     */
    userFamilyNameKana?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser
     */
    userFirstNameKana?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser
     */
    userSex?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser
     */
    userPostalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser
     */
    userAddress1?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser
     */
    userAddress2?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser
     */
    userTelKind?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser
     */
    userTel?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser
     */
    userTel2?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser
     */
    userEmail?: string;
}

export function JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUserFromJSON(json: any): JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser {
    return JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUserFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userName': !exists(json, 'userName') ? undefined : json['userName'],
        'userNameKana': !exists(json, 'userNameKana') ? undefined : json['userNameKana'],
        'userRelationShip': !exists(json, 'userRelationShip') ? undefined : json['userRelationShip'],
        'userAge': !exists(json, 'userAge') ? undefined : json['userAge'],
        'userFamilyName': !exists(json, 'userFamilyName') ? undefined : json['userFamilyName'],
        'userFirstName': !exists(json, 'userFirstName') ? undefined : json['userFirstName'],
        'userFamilyNameKana': !exists(json, 'userFamilyNameKana') ? undefined : json['userFamilyNameKana'],
        'userFirstNameKana': !exists(json, 'userFirstNameKana') ? undefined : json['userFirstNameKana'],
        'userSex': !exists(json, 'userSex') ? undefined : json['userSex'],
        'userPostalCode': !exists(json, 'userPostalCode') ? undefined : json['userPostalCode'],
        'userAddress1': !exists(json, 'userAddress1') ? undefined : json['userAddress1'],
        'userAddress2': !exists(json, 'userAddress2') ? undefined : json['userAddress2'],
        'userTelKind': !exists(json, 'userTelKind') ? undefined : json['userTelKind'],
        'userTel': !exists(json, 'userTel') ? undefined : json['userTel'],
        'userTel2': !exists(json, 'userTel2') ? undefined : json['userTel2'],
        'userEmail': !exists(json, 'userEmail') ? undefined : json['userEmail'],
    };
}

export function JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUserToJSON(value?: JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userName': value.userName,
        'userNameKana': value.userNameKana,
        'userRelationShip': value.userRelationShip,
        'userAge': value.userAge,
        'userFamilyName': value.userFamilyName,
        'userFirstName': value.userFirstName,
        'userFamilyNameKana': value.userFamilyNameKana,
        'userFirstNameKana': value.userFirstNameKana,
        'userSex': value.userSex,
        'userPostalCode': value.userPostalCode,
        'userAddress1': value.userAddress1,
        'userAddress2': value.userAddress2,
        'userTelKind': value.userTelKind,
        'userTel': value.userTel,
        'userTel2': value.userTel2,
        'userEmail': value.userEmail,
    };
}

